const idr = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  maximumFractionDigits: 0,
});

export function formatIDR(value: number): string {
  return idr.format(value).replace(/\s/g, " ");
}

export function formatShortIDR(value: number): string {
  return `${Math.round(value / 1000)}K`;
}
